import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=6179%3A10639
 *
 * @param {SvgIconProps} props - svg props
 */
export const PlaceholderIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M0 5C0 2.23858 2.23858 0 5 0H19C21.7614 0 24 2.23858 24 5V19C24 21.7614 21.7614 24 19 24H5C2.23858 24 0 21.7614 0 19V5ZM1.25 5C1.25 3 3 1.25 5 1.25H19C21 1.25 22.75 2.8125 22.75 5C22.75 7.1875 22.75 19 22.75 19C22.75 21 21 22.75 19 22.75H5C3 22.75 1.25 21 1.25 19V5Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M20.3077 7.15385L18.9231 5.76923L12.6923 12L18.9231 18.2308L20.3077 16.8462L21 21L16.8462 20.3077L18.2308 18.9231L12 12.6923L5.76923 18.9231L7.15385 20.3077L3 21L3.69231 16.8462L5.07692 18.2308L11.3077 12L5.07695 5.76923L3.69233 7.15385L3.00002 3L7.15387 3.69231L5.76925 5.07692L12 11.3077L18.2308 5.07692L16.8462 3.69231L21 3L20.3077 7.15385Z' fill={color}/>
        </SvgIcon>
    )
}

export default PlaceholderIcon
